<template>
  <vue-multiselect
    :show-labels="false"
    :value="value"
    :multiple="false"
    group-values="markets"
    group-label="typeLabel"
    label="name"
    track-by="name"
    :options="options"
    :hide-selected="false"
    :disabled="disabled"
    :option-height="44"
    class="vuemultiselect market-selector"
    :class="{ 'selected': value }"
    @select="selected"
  >
    <template
      slot="beforeList"
    >
      <div class="market-list-actions">
        <button class="button-add" @click="$emit('add')">
          <img src="~@/assets/icon-add.svg" class="icon">
          Add
          <span class="show-from-tablet">&nbsp; Market </span>
        </button>
        <file-uploader
          class="button-upload"
          accept=".json"
          :formats="['application/json']"
          multiple
          @error="error => $emit('upload-errored', error)"
          @load="files => $emit('uploaded', files)"
        >
          <img src="~@/assets/icon-import.svg" class="icon">
          Upload
          <span class="show-from-tablet">&nbsp; Market </span>
        </file-uploader>
      </div>
    </template>
    <template
      slot="option"
      slot-scope="{ option }"
    >
      <div v-if="option.$isLabel" class="group-label">
        {{ option.$groupLabel }}
      </div>
      <div v-else class="option">
        <span class="option-label">
          {{ typeof option === 'string' ? option : option.name }}
        </span>
        <div v-if="isCustom(option)" class="custom-market-actions">
          <img
            src="~@/assets/icon-export.svg"
            class="icon"
            @click.stop="$emit('export', option)"
          >
          <img
            src="~@/assets/icon-edit.svg"
            class="icon"
            @click.stop="$emit('edit', option)"
          >
          <img
            src="~@/assets/icon-remove.svg"
            class="icon"
            @click.stop="$emit('remove', option)"
          >
        </div>
      </div>
    </template>
  </vue-multiselect>
</template>

<script>
import VueMultiselect from 'vue-multiselect/src/Multiselect';
import FileUploader from '@/components/common/FileUploader';

export default {
  name: 'MarketSelector',
  components: {
    VueMultiselect,
    FileUploader,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    customMarkets: {
      type: Array,
      default: () => [],
    },
    staticMarkets: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    options() {
      const customMarkets = { typeLabel: 'Custom Markets', markets: this.customMarkets };
      const staticMarkets = { typeLabel: 'All Markets', markets: this.staticMarkets };
      return [customMarkets, staticMarkets];
    },
    isCustom() {
      return option => this.customMarkets.find(market => market.id === option.id);
    },
  },
  methods: {
    selected(item) {
      this.$emit('selected', item);
    },
  },
};
</script>

<style lang="scss">
  /* Please note style is not scoped because of the fact we
   * are overriding the styles for vue-multiselect component */

  @import "~@/assets/scss/vuemultiselect";

  .market-selector {
    .multiselect__content {
      max-width: 100%;
    }
    .multiselect__option {
      height: $control-size;
      padding: 10px;
      display: flex;
      align-items: center;
      font-size: 15px;
    }

    .multiselect__option--group {
      height: 25px;
      padding: 5px 10px;
      margin: 10px 0 6px 0;
    }

    .multiselect__option--highlight,
    .multiselect__option--selected.multiselect__option--highlight {
      background: $silver-bright;
    }

    .multiselect__option--selected {
      background: $input-focus-background-color;
      font-weight: inherit;
    }
  }
</style>
<style lang="scss" scoped>
  @import "~@/assets/scss/variables";
  @import "~@/assets/scss/buttons";
  @import "~@/assets/scss/general";
  @import '~@/assets/scss/inputs';
  @import "~@/assets/scss/mixins";

  .market-list-actions {
    display: flex;
    align-items: center;
    padding: 10px 10px 0 10px;
    margin-bottom: 10px;

    .button-add {
      @include button;
      margin-right: 8px;

      .icon {
        margin-bottom: 1px;
      }
    }

    .button-upload {
      @include button($input-focus-background-color, #4B4B4B);

      .icon {
        margin-bottom: 3px;
      }
    }

    .button-add,
    .button-upload {
      width: 50%;

      @include until($mobile) {
        min-width: auto;
      }
    }
  }

  .option {
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    font-size: 17px;

    .option-label {
      flex: 1;
    }

    .custom-market-actions {
      margin-right: -6px;
    }

    .icon {
      width: auto;
      height: 32px;
      padding: 8px;
      box-sizing: border-box;

      & + & {
        margin-left: 2px;
      }
    }
  }

  .group-label {
    color: $grey !important;
    font-size: 12px;
    font-weight: $weight-bold;
    line-height: 15px;
  }
</style>
